<script setup lang="ts">
import { Product } from "~/utils/Product";
import { useModyApi } from '~/middelware/ModyApi';

useSeoMeta({
  title: "Sortiment",
  ogTitle: "Sortiment"
})

const searchString = ref("")
const api = useModyApi();
const searchResults = ref<Product[]>()
const router = useRouter()
const inputTextOutside = ref<HTMLElement | null>(null)
const inputTextModal = ref<HTMLElement | null>(null)
async function search(){
  if(searchString.value.length >= 3){
    searchResults.value = await api.searchProducts(searchString.value)
  }
}
const searchOpen = computed(()=>{
  return searchString.value.length >= 3
})
watch(router.currentRoute, ()=>{
  searchString.value = ""
})
watch(searchOpen,(value, oldValue, onCleanup)=>{
  if(searchOpen.value){
    if(inputTextModal.value){
      inputTextModal.value.$el.focus()
    }
  }
  else if(oldValue === true){
    //If search was open
    if(inputTextOutside.value){
      console.log("focus")
      inputTextOutside.value.$el.focus()
    }
  }
})

</script>
<template>
  <div class="shop-container">
    <div class="flex justify-content-end">
      <InputGroup class="m-3 h-10 lg:w-[280px] lg:h-10 lg:mb-4 lg:mr-2">
      <InputGroupAddon>
        <i class="pi pi-search"></i>
      </InputGroupAddon>
      <InputText ref="inputTextOutside" v-model="searchString" @input="search" placeholder="Suche"  />
    </InputGroup>
    </div>
    <div class="search-container bg-slate-800" v-if="searchOpen">
      <div class="text-2xl bold mb-3">Suche</div>
      <div class="flex justify-center">
        <InputGroup class="w-2/5">
          <InputGroupAddon>
            <i class="pi pi-search" />
          </InputGroupAddon>
          <InputText ref="inputTextModal" v-model="searchString" @input="search" placeholder="Suche"  />
        </InputGroup>
      </div>

      <div class="item-container">
        <ShopProductItem :product="product" v-for="product in searchResults"></ShopProductItem>
      </div>
    </div>
    <NuxtPage />
  </div>
</template>
<style scoped lang="scss">

.searchbar{
  left: 50%;
  margin: auto;
  width: 80%;
  .p-inputtext{
    width: 100%;
    height:40px;
  }
  @include desktop(){
    left:unset;
    width:280px;
    margin-left: auto;
    margin-right: 1rem;
  }
}
.search-container{
  position:fixed;
  padding:20px;
  width: calc(100% + 1px);
  height: calc(100%);
  z-index:2;
  top:0;
}
.item-container{
  height: calc(100% - 50px);
  overflow:scroll;
  padding-bottom:30px;
}
</style>
